import { googleLogin, facebookLogin } from 'actions/auth';

export const googleAuth = async (dispatch) => {
  await dispatch(googleLogin());
};

export const facebookAuth = async (dispatch) => {
  await dispatch(facebookLogin());
};
